import { fade, alpha } from '@material-ui/core';

const SearchTimeStyle = (theme) => ({
  dateRangeWrapper: {
    display: 'flex',
    paddingTop: theme.spacing(2),
    position: 'relative',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    '& .DateRangePicker': {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        minWidth: theme.spacing(30),
      },
      '&>div': {
        height: '100%',
      },
      '& .DateRangePickerInput': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .DateRangePickerInput__disabled': {
        background: 'transparent',
      },
      '& .DateRangePickerInput__withBorder': {
        border: 0,
      },
    },
    '& .DateRangePicker_picker': {
      zIndex: '99',
    },
    // inputs wrapper
    '& .DateRangePickerInput__showClearDates': {
      display: 'flex',
      alignItems: 'center',
      border: 'none',
      height: '100%',
      paddingRight: theme.spacing(2),
      backgroundColor: theme.palette.common.white,
    },
    // day style
    '& .CalendarDay__selected_span, .CalendarDay__hovered_span, CalendarDay__hovered_span:hover': {
      background: `${fade(theme.palette.primary.main, 0.3)} !important`,
      border: `1px double ${fade(theme.palette.primary.main, 0.3)}`,
      color: `${theme.palette.grey[600]} !important`,
    },
    '& .CalendarDay__selected, .CalendarDay__selected:active, .CalendarDay__selected:hover, .CalendarDay__selected_span:hover, .CalendarDay__hovered_span:hover':
      {
        background: `${theme.palette.primary.main} !important`,
        border: `1px double ${theme.palette.primary.main}`,
        color: `${theme.palette.common.white} !important`,
      },
    '& .CalendarDay__default:hover': {
      background: `${fade(theme.palette.primary.main, 0.5)}`,
    },
    // days out of range
    '& .CalendarDay__blocked_out_of_range, .CalendarDay__blocked_out_of_range:active, .CalendarDay__blocked_out_of_range:hover':
      {
        color: `${fade(theme.palette.secondary.main, 0.5)} !important`,
        background: 'transparent',
      },
    // months navigations
    '& .DayPickerNavigation__horizontal': {
      display: 'flex',
      justifyContent: 'space-between',
      top: theme.spacing(3),
      padding: theme.spacing(0, 2),
    },
    '& .DayPickerNavigation_button': {
      width: theme.spacing(3),
      height: theme.spacing(3),
      '& svg': {
        fill: theme.palette.primary.main,
      },
    },
    // month name
    '& .CalendarMonth_caption': {
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 'bold',
      textTransform: 'uppercase',
    },
    // Calendar Icon
    '& .DateRangePickerInput_calendarIcon': {
      margin: '0',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      paddingRight: 0,
      '& svg': {
        width: theme.spacing(2),
        // [theme.breakpoints.down('md')]: {
        //   width: theme.spacing(3),
        //   height: theme.spacing(3),
        // },
      },
    },
    // Input
    '& .DateInput': {
      width: theme.spacing(10),
      height: '100%',
    },
    '& .DateInput_input__focused': {
      borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    '& .DateInput_input': {
      fontSize: theme.typography.pxToRem(14),
      paddingLeft: theme.spacing(0.5),
      paddingRight: 0,
      color: fade(theme.palette.common.black, 0.87),
      height: '100%',
      backgroundColor: theme.palette.common.white,
      fontStyle: 'normal',
      '&::placeholder': {
        color: 'black',
        opacity: '0.8',
      },
    },
    // clear Icon
    '& .DateRangePickerInput_clearDates': {
      marginRight: 0,
      height: '100%',
      '& svg': {
        width: theme.spacing(2),
      },
    },
    '& .DateRangePickerInput_arrow': {
      margin: theme.spacing(0, 1, 0, 0),
      // arrow Icon
      '& svg': {
        fill: `${theme.palette.secondary.main}`,
        width: theme.spacing(2),
      },
    },
    // top arrow
    '& .DateInput_fang': {
      display: 'none',
    },
  },
  dateLabel: {
    color: fade(theme.palette.common.black, 0.54),
    fontSize: theme.typography.pxToRem(12),
    position: 'absolute',
    top: theme.spacing(1.625),
    left: theme.spacing(4),
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
      top: theme.spacing(1),
    },
  },
  calendarRoot: {
    width: '100%',
    position: 'relative',
    height: '99%',
    // override ER
    '& td': {
      padding: '0',
      outline: 'none',
    },
    '& tr': {
      borderBottom: '0',
    },
    '& .DateRangePicker': {
      position: 'relative',
      zIndex: '4',
      maxWidth: '100%',
      minWidth: '100%',
      height: '100%',
      '& > div': {
        height: '100%',
      },
      '& .DayPicker_weekHeader': {
        top: theme.spacing(6.5),
      },
      '& .DateRangePicker_picker': {
        [theme.breakpoints.up('md')]: {
          top: `${theme.spacing(7.75)} !important`,
        },
      },
    },
    //
    '& .DateRangePickerInput__withBorder': {
      borderTop: '0',
      borderBottom: '0',
    },
    // calendar icon
    '& .DateRangePickerInput_calendarIcon': {
      padding: '0',
      margin: '0 10px',
      '& svg': {
        margin: '0',
        width: '12px',
      },
    },
    '&.filled': {
      '& .DateRangePickerInput_calendarIcon': {
        marginTop: '12px',
      },
    },
    '&.disabledContainer': {
      '& .DateRangePickerInput_clearDates': {
        display: 'none',
      },
    },
    // dash between dates
    '& .DateRangePickerInput_arrow': {
      opacity: '0',
      display: 'none',
    },
    '& .DateInput .DateInput_input': {
      padding: '0',
      margin: '0',
      border: 'none',
      fontSize: '14px',
      height: '100%',
    },
    '& .DateInput:nth-of-type(1)': {
      width: '100%',
    },
    // inputs
    '& .DateRangePickerInput': {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      height: '100%',
    },
    '& .DateInput': {
      // width: 'auto',
      backgroundColor: 'transparent',
      opacity: '0',
      height: '100%',
      width: '0',
    },
    // clear dates
    '& .DateRangePickerInput_clearDates': {
      margin: '0',
      bottom: '0',
      transform: 'none',
      top: '23%',
      '& svg': {
        margin: '0',
        width: '16px',
        fill: '#242424',
      },
      '&:hover, &:focus': {
        background: 'transparent',
      },
    },
    // day style
    '& .CalendarDay__selected_span, .CalendarDay__hovered_span, CalendarDay__hovered_span:hover': {
      background: alpha(theme.palette.primary.main, 0.3),
      border: `1px double ${alpha(theme.palette.primary.main, 0.3)}`,
      color: '#303030',
    },
    '& .CalendarDay__selected, .CalendarDay__selected:active, .CalendarDay__selected:hover': {
      background: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      color: `${theme.palette.common.black} !important`,
    },
    // months navigations
    '& .DayPickerNavigation__horizontal': {
      display: 'flex',
      justifyContent: 'space-between',
      top: '24px',
      padding: '0 16px',
    },
    '& .DayPickerNavigation_button': {
      width: '24px',
      height: '24px',
      '& svg': {
        fill: theme.palette.secondary.main,
      },
    },
    // month name
    '& .CalendarMonth_caption': {
      fontFamily: theme.typography.fontFamilySecondary,
      fontSize: theme.typography.pxToRem(16),
      textTransform: 'uppercase',
    },
    '@media (min-width: 1024px)': {
      '& .DateRangePicker_picker': {
        marginTop: '13px',
      },
    },
    // small screens
    '@media (max-width: 1023px)': {
      '& .DateRangePicker_picker': {
        minWidth: '100%',
      },
      '& .DayPicker__withBorder': {
        minWidth: '100%',
        boxShadow: 'none',
        borderRadius: '0',
        // marginTop: '60px',
        '& .DayPicker_weekHeader': {
          top: theme.spacing(6.5),
        },
      },
    },
    '@media (max-width: 768px)': {
      '& .DayPicker__withBorder': {
        '& > div > div': {
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },
    '& input[type=text]:not(.browser-default):focus:not([readonly])': {
      borderBottom: '0',
      boxShadow: 'none',
    },
    '& .MuiInput-underline:after': {
      // borderBottom: '1px solid #5d5d5d',
      // boxShadow: '0 1px 0 0 #5d5d5d',
      borderBottom: '0',
      boxShadow: 'none',
    },
  },
});

export default SearchTimeStyle;
